export interface EmailFormValue {
  email: string;
}

export enum ModalPhases {
  EMAIL,
  PASSWORD,
}
